<template>
  <div>
    <!-- empty error message -->
    <alert
      v-if="stakeholders.length === 0 && errorMessage.length === 0"
      :class="{'error': hasError}"
      :text-prop="emptyMessage"/>

    <!-- ajax error message -->
    <alert
      v-if="errorMessage.length !== 0"
      :class="{'error': hasError}"
      :text-prop="errorMessage"/>

    <template v-if="showGroupedStakeholders">
      <div
        v-for="(groups, key) in stakeholders"
        :key="key"
        class="stakeholder-grouped-results">
        <div
          v-for="(group, level) in groups"
          :key="level"
          class="stakeholder-group">
          <h4 class="group-label">{{ level }}</h4>
          <stakeholder
            v-for="stakeholder in group"
            :key="stakeholder.stakeholderId"
            :id="stakeholder.stakeholderId"
            v-bind="stakeholder"/>
        </div>
      </div>
    </template>

    <template v-if="!showGroupedStakeholders">
      <stakeholder
        v-for="stakeholder in stakeholders"
        :key="stakeholder.stakeholderId"
        :id="stakeholder.stakeholderId"
        v-bind="stakeholder"/>
    </template>

    <primary-button
      v-if="showButton && !errorMessage && stakeholders.length"
      :disabled="buttonDisabled"
      class="btn--lg"
      @click.native="$emit('click')"
    >
      <span v-html="buttonText"/>
    </primary-button>
  </div>
</template>

<script>
import Stakeholder from "WhoDoYouKnowComponents/Stakeholder.vue";
import PrimaryButton from "WhoDoYouKnowComponents/buttons/PrimaryButton.vue";
import Alert from "WhoDoYouKnowComponents/Alert.vue";

export default {
  name: "StakeholderResultList",
  components: {
    Alert,
    PrimaryButton,
    Stakeholder
  },
  props: {
    buttonDisabled: {
      type: Boolean,
      default: false
    },
    buttonText: {
      type: String,
      default: "Continue"
    },
    emptyMessage: {
      type: String,
      required: true
    },
    errorMessage: {
      type: String,
      required: true
    },
    hasError: {
      type: Boolean,
      default: false
    },
    showButton: {
      type: Boolean,
      default: true
    },
    stakeholders: {
      type: Array,
      required: true
    },
    isSearchResult: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    showGroupedStakeholders() {
      return (
        this.errorMessage || (this.stakeholders.length && !this.isSearchResult)
      );
    }
  }
};
</script>
